import TStrings from './Questions.i18n';

export const QuestionCategories = [
    TStrings.QUESTION_CATEGORY_LOGIN,
    TStrings.QUESTION_CATEGORY_CONTACT_INFO,
    TStrings.QUESTION_CATEGORY_TEXT,
    TStrings.QUESTION_CATEGORY_CHOICE,
    TStrings.QUESTION_CATEGORY_SCHEDULING,
    TStrings.QUESTION_CATEGORY_SELLING,
    TStrings.QUESTION_CATEGORY_DISPLAY,
    TStrings.QUESTION_CATEGORY_LEGAL,
];

export const ThankYouQuestionCategories = [
    TStrings.QUESTION_CATEGORY_LOGIN,
    TStrings.QUESTION_THANK_YOU_CATEGORY_DISPLAY,
    TStrings.QUESTION_THANK_YOU_CATEGORY_CONFIRMATION,
];

export enum QuestionType {
    Scheduling = 'scheduling',
    ClassScheduling = 'classscheduling',
    AddOn = 'addon',
    Packages = 'packages',
    YesNo = 'yesno',
    AgreeToTerms = 'agreetoterms',
    Checkboxes = 'checkboxes',
    Dropdown = 'dropdown',
    Radios = 'radios',
    Text = 'text',
    BigText = 'bigtext',
    Date = 'date',
    Location = 'location',
    Display = 'display',
    ContactInfo = 'contactinfo',
    Email = 'email',
    Upload = 'upload',
    Phone = 'phone',
    ThankYou = 'thankyou',
    Signature = 'signature',
    Payment = 'payment',
    Hidden = 'hidden',
    ClientAccount = 'clientaccount',
    GiftCertificate = 'giftcertificate',
}
